const system = {
    Vb: 1,
    Von: 2,
    Blikk: 4,
    Voss: 5
}

export default system;

export const sourceSystemText = {
    [system.Vb]: "VB",
    [system.Von]: "VON",
    [system.Blikk]: "Blikk",
    [system.Voss]: "VOSS"
}